import React from "react";
import { Button, Icon, IconProps } from "semantic-ui-react";

import SimpleButton, { definedButtonTypes } from "./SimpleButton/SimpleButton";

import { styledWithTheme } from "../../../styles/theme";

// TODO: Groom @Agnese
export interface MediaButtonProps {
  id: string;
  media: definedMedia;
  href?: string;
  type?: definedMediaButtonTypes;
  icon?: boolean;
  onClick?(event: React.MouseEvent): void;
}

export enum definedMediaButtonTypes {
  default = "default",
  simple = "simple",
}

export enum definedMedia {
  facebook = "facebook",
  twitter = "twitter",
  google = "google",
  instagram = "instagram",
  youtube = "youtube",
  linkedin = "linkedin",
  website = "website",
}

function formatMediaName(media: definedMedia) {
  switch (media) {
    case definedMedia.facebook:
      return "Facebook";
    case definedMedia.google:
      return "Google";
    case definedMedia.instagram:
      return "Instagram";
    case definedMedia.linkedin:
      return "LinkedIn";
    case definedMedia.twitter:
      return "Twitter";
    case definedMedia.youtube:
      return "YouTube";
    default:
      return "Website";
  }
}

const StyledButton = styledWithTheme(Button)(({ theme }) => ({
  "&&&": {
    background: theme.palette.mono.light,
    ".icon": {
      color: theme.palette.mono.white,
    },
    "&:hover": {
      background: theme.palette.mono.base,
    },
  },
}));

const MediaButton: React.FC<MediaButtonProps> = ({
  media,
  icon,
  type,
  href,
  onClick,
  id,
}) => {
  let iconName: IconProps["name"] = media as IconProps["name"];

  if (media === definedMedia.google) {
    iconName = "google";
  }
  if (media === definedMedia.website) {
    iconName = "world";
  }

  if (icon) {
    return (
      <StyledButton
        id={id}
        icon={iconName}
        circular
        href={href}
        onClick={onClick}
        target="_blank"
      />
    );
  }

  if (type === definedMediaButtonTypes.simple) {
    return (
      <SimpleButton
        variant={definedButtonTypes.social}
        id={id}
        onClick={onClick}
      >
        <Icon name={iconName} /> {formatMediaName(media)}
      </SimpleButton>
    );
  }

  return (
    <Button id={id} onClick={onClick}>
      <Icon name={iconName} /> {formatMediaName(media)}
    </Button>
  );
};

export default MediaButton;
